import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTableColumns,
  faUsers,
  faExclamationTriangle,
  faClipboardList,
  faCheckCircle,
  faLock,
  faChartLine,
  faLifeRing, faFileInvoiceDollar, faBuilding, faWallet, faGift, faBox, faGears,
} from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  "tachometer-alt": faTableColumns,
  users: faUsers,
  "exclamation-triangle": faExclamationTriangle,
  "clipboard-list": faClipboardList,
  "check-circle": faCheckCircle,
  lock: faLock,
  building: faBuilding,
  invoice: faFileInvoiceDollar,
  pricing: faWallet,
  gift: faGift,
  "gift-request": faBox,
  "chart-line": faChartLine,
  "life-ring": faLifeRing,
  "cogs": faGears,
};
const SidebarButtonAdmin = ({ label, icon, active, onClick, expand }) => {
  const buttonStyle = {
    paddingTop: 10,
    zIndex: 999999999,
    paddingBottom: 10,
    borderRadius: 10,
    justifyContent: !expand ? "center" : "flex-start",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    background: active ? "white" : "transparent",
    color: active ? "#00BED4" : "whitesmoke",
    width: expand ? "%100" : "fit-content"
  };
  return (
    <div className="transition-all !px-2 w-full flex" style={buttonStyle} onClick={onClick}>
      <FontAwesomeIcon icon={iconMap[icon]} style={{ width: 24, height: 24 }} />
      {!expand ? null : (
        <div
          style={{
            fontSize: 14,
            fontFamily: "revert",
            fontWeight: "600",
            wordWrap: "break-word",
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
};

export default SidebarButtonAdmin;
